import { forwardRef, useEffect, useState } from 'react';
import './faq.css';
import CharCount from '../../charCount/CharCount';
import useSectionHighlightRef from '../../../hooks/useSectionHighlightRef';

const FAQ = forwardRef(({ packData, setPackData, isEdit }, ref) => {
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    const [queCount, setQueCount] = useState(packData?.FAQ?.length);

    useEffect(() => {
        setQueCount(packData?.FAQ?.length);
    }, [packData?.FAQ?.length]);

    function handleFAQ(e, index) {
        const { name, value } = e.target;
        let key = name;
        if (name.startsWith('question')) {
            key = 'question';
        } else if (name.startsWith('answer')) {
            key = 'answer';
        }
        setPackData((prevState) => {
            const updatedArrya = prevState.FAQ.map(function (item, itemKey) {
                if (index === itemKey) {
                    const key = name.startsWith('question') ? 'question' : 'answer';
                    return { ...item, [key]: value };
                }
                return item;
            });
            return {
                ...prevState,
                FAQ: updatedArrya
            };
        });
    }

    function addQuestion() {
        setPackData(function (prevState) {
            return {
                ...prevState,
                FAQ: [...prevState.FAQ, { question: '', answer: '' }]
            };
        });
        setQueCount(queCount + 1);
    }

    function deleteQuestion() {
        if (queCount > 1) {
            console.log('hi');
            setPackData(function (prevState) {
                const updatedArrya = [...prevState.FAQ];
                updatedArrya.pop(); //pop should used here only, if use pop in the above line, it returns
                //the removed item which is not the expected outcome
                return {
                    ...prevState,
                    FAQ: updatedArrya
                };
            });
            setQueCount(queCount - 1);
        }
    }

    return (
        <div ref={sectionRef}>
            <h2 className='orgPackUpH2'>FAQ</h2>
            <div className='orgPackUpSecDiv'>
                {(packData?.FAQ?.length > 1 ? packData.FAQ : Array.apply(null, { length: queCount })).map(
                    function (_, itnKey) {
                        return (
                            <div key={itnKey}>
                                <p className='itineraryLabel'>Question {itnKey + 1}</p>
                                <div className='itineraryInDiv'>
                                    <label className='itineraryLabel'>Question</label>
                                    <div className='itineraryInputDiv'>
                                        <input
                                            value={packData.FAQ[itnKey] ? packData.FAQ[itnKey].question : ''}
                                            name={`question${itnKey}`}
                                            type='text'
                                            onChange={(e) => handleFAQ(e, itnKey)}
                                            placeholder={`Question ${itnKey + 1}`}
                                            className={`itineraryInput ${
                                                highlightField === `question${itnKey}` ? 'error-highlight' : ''
                                            }`}
                                        ></input>
                                        <CharCount
                                            string={packData.FAQ[itnKey] ? packData.FAQ[itnKey].question : ''}
                                            min={5}
                                            limit={300}
                                        />
                                    </div>
                                </div>
                                <div className='itineraryDiv'>
                                    <label className='itineraryLabel'>Answer</label>
                                    <div className='itineraryInputDiv'>
                                        <textarea
                                            value={packData.FAQ[itnKey] ? packData.FAQ[itnKey].answer : ''}
                                            name={`answer${itnKey}`}
                                            onChange={(e) => handleFAQ(e, itnKey)}
                                            placeholder={`Answer ${itnKey + 1}`}
                                            className={`itineraryInput textArea ${
                                                highlightField === `answer${itnKey}` ? 'error-highlight' : ''
                                            }`}
                                            style={{ minHeight: '90px' }}
                                        ></textarea>
                                        <CharCount
                                            string={packData.FAQ[itnKey] ? packData.FAQ[itnKey].answer : ''}
                                            min={2}
                                            limit={500}
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    }
                )}
                <div className='alignButtons'>
                    <button type='button' onClick={addQuestion} className='itineraryAddBtn blueBtn'>
                        Add Question
                    </button>
                    <button
                        type='button'
                        onClick={deleteQuestion}
                        className='itineraryDelBtn'
                        disabled={queCount === 1 ? true : false}
                    >
                        Delete Question
                    </button>
                </div>
            </div>
        </div>
    );
});

export default FAQ;
